import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { fetchStart, fetchSuccess } from '../../appRedux/actions';
import { axiosInstance, BASE_API_CONFIG } from '../../util/Api';
import { Button, Card, DatePicker, Form, Modal, notification, Select, Space, Table, Tag } from 'antd';
import { useGetBreakpoints } from '../../hooks/useGetBreakpoints';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch, useSelector } from 'react-redux';
import { formatDate, isBuyer, isExporter, isManufacturerCumExporter } from '../../util/helper';
import { BUSINESS_TYPE, RFQ_STATUS, RFQ_TYPE } from '../../util/Constant';
import { CheckCircleFilled, ExclamationCircleFilled, EyeOutlined, InfoCircleFilled, RocketOutlined } from '@ant-design/icons';
import { isArrayNonEmpty } from '../../util/ApiHelper';
import BuyerOfferProductModal from './BuyerOfferProductModal';
import moment from "moment";
import ListEmptyComponent from '../../components/ListEmptyComponent/ListEmptyComponent';


const AdminToBuyerOfferProductList = () => {
  const { isMobile } = useGetBreakpoints();
  const history = useHistory();
  const dispatch = useDispatch();
  const userData = useSelector(({ auth }) => auth?.userData);
  const userId = userData.id;
  const [userSubscription, setUserSubscription] = useState(null);
  const { loading } = useSelector(({ common }) => common);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isNegotiation, setIsNegotiation] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [form] = Form.useForm();
  const location = useLocation();
  const path = location.pathname;
  const hasCloneParam = path.includes("clone");
  // const buyerOfferProduct = useSelector(
  //   (state) => state.exporterOfferProducts.buyerProductDetailsById
  // );
  const [buyerOfferProduct, setBuyerOfferProduct] = useState(null);
  const [targetedBusinessType, setTargetedBusinessType] = useState(null);
  const [buyerProductData, setBuyerProductData] = useState(null);
  const [loadingProduct, setLoadingProduct] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [offerProductListBuyer, setOfferProductListBuyer] = useState({
    data: [],
    meta: {}
  });

  const getAdminToBuyerOfferProducts = async (page = currentPage, limit = pageSize) => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/admin-offer-products/buyer/?page=${page}&limit=${limit}`
      );
      setOfferProductListBuyer(response?.data);
    } catch (error) {
      notification.error({
        message: "Failed",
        description:
          error?.response?.data?.message || "Failed to fetch admin offers to buyer"
      });
    } finally {
      dispatch(fetchSuccess());
    }
  };

  useEffect(() => {
    getAdminToBuyerOfferProducts();
  }, [currentPage, pageSize])

  const getAdminToBuyerOfferProductsById = async (id) => {
    try {
      dispatch(fetchStart());
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/admin-offer-products/buyer/${id}`
      );
      console.log('response',response)
      setBuyerOfferProduct(response?.data?.data);
      setBuyerProductData(response?.data?.data); // set immediately for modal use
    } catch (error) {
      notification.error({
        message: "Failed",
        description:
          error?.response?.data?.message ||
          "Failed to fetch admin offer product details",
      });
    } finally {
      dispatch(fetchSuccess());
    }
  };

  const FOR_DESTINATIONS = [
    "Mundra Port",
    "Nhava Sheva",
    "Kakinada",
    "Gandhidham",
    "Chennai",
  ];

  const [selectedDestination, setSelectedDestination] = useState("Mundra Port");

  useEffect(() => {
    if (
      isBuyer(userData) ||
      isExporter(userData) ||
      isManufacturerCumExporter(userData)
    ) {
      form.setFieldValue("sourceCountry", "India");
      setTargetedBusinessType([
        ...[BUSINESS_TYPE.EXPORTER, BUSINESS_TYPE.MANUFACTURER_EXPORTER],
      ]);
    }
  }, [userData]);

  const openModal = async (record, type) => {
    setLoadingProduct(true);
    setSelectedRecord(record);
    setIsNegotiation(type === "negotiate");
    await getAdminToBuyerOfferProductsById(record.id);
    setIsModalVisible(true);
    setLoadingProduct(false);
  };

  useEffect(() => {
    if (buyerOfferProduct && Object.keys(buyerOfferProduct).length > 0) {
      setBuyerProductData(buyerOfferProduct);
    }
  }, [buyerOfferProduct]);
  console.log('buyerProductData',buyerProductData)
  const handleSave = async () => {
    setIsSubmitting(true);
    dispatch(fetchStart());
    console.log('productData test')
    if (!buyerProductData) {
      notification.warning({
        message: "Please wait",
        description: "There is a issue in displaying product details.",
      });
      return;
    }
    try {
      const values = await form.validateFields();
      const {
        noOfUnits,
        destinationCountry,
        destinationPort,
        comment,
        currency,
        negotiatePricePerUnit,
        expectedLoadingDate,
        deliveryLocation
      } = values;

      let productData = buyerProductData?.data || buyerProductData;
      // if (!productData && selectedRecord) {
      //   setLoadingProduct(true);
      //   // await dispatch(getBuyerOfferProductsById({ id: selectedRecord.id }));
      //   productData = buyerOfferProduct; // Use the data from Redux store
      //   setLoadingProduct(false);
      // }
      console.log('productData',productData)
      if (!productData) {
        notification.error({
          message: "Error",
          description: "Unable to load product details",
        });
        return;
      }
      const data = {
        productName: productData?.name,
        description: comment,
        qty: noOfUnits,
        categoryId: productData?.categoryId,
        hsCodeId: productData?.hsCodeId,
        units: productData?.uom,
        destinationCountry: destinationCountry,
        destinationPort: destinationPort,
        isDuplicate: hasCloneParam,
        businessTypeId: productData?.businessTypeIds?.[0],
        userId: userId,
        exporterUserId: productData?.userId,
        status: RFQ_STATUS.SUBMITTED,
        productImages: productData?.primaryImage
          ? [
            {
              src: productData?.primaryImage,
              originalName: productData?.primaryImage?.split("/").pop(),
            },
          ]
          : [],
        targetedBusinessType: targetedBusinessType,
        paymentTerms: productData?.paymentTerms,
        currency: currency,
        negotiatePricePerUnit: negotiatePricePerUnit,
        productId: productData?.productId,
        expiryDate: productData?.expiryDate,
        name: productData?.name,
        categoryName: productData?.product?.categories?.name,
        isActive: productData?.isActive,
        rfqType: isNegotiation ? RFQ_TYPE?.NEGOTIATE : RFQ_TYPE.RATE_BLOCKED,
        expectedLoadingDate: expectedLoadingDate,
        deliveryLocation: deliveryLocation,
      };
      await axiosInstance.post(`${BASE_API_CONFIG.baseURL}/enquiries`, data);
      notification.success({
        message: "Success",
        description:
          "Your request has been submitted successfull you can view this under My RFQ",
      });

      setIsModalVisible(false);
      form.resetFields();
    } catch (err) {
      console.error("Error while saving offer product:", err);
      notification.error({
        message: "Error",
        description: err.message || "Something went wrong while saving data.",
      });
    } finally {
      dispatch(fetchSuccess());
      setIsSubmitting(false);
    }
  };

  const filteredOfferProductList = useMemo(() => {
    let result = offerProductListBuyer?.data?.filter((item) => {
      if (selectedDate) {
        const itemDate = moment(item.updatedAt).format("YYYY-MM-DD");
        const selectedDateFormatted = moment(selectedDate).format("YYYY-MM-DD");
        return itemDate === selectedDateFormatted;
      }
      return true;
    });

    if (isBuyer(userData)) {
      result = result.filter((item) => item.paymentTerms === "FOB");
    }

    if (!isBuyer(userData)) {
      result = result.filter((item) => {
        if (selectedDestination) {
          return item.forDestination === selectedDestination;
        }
        return true;
      });
    }

    return result;
  }, [offerProductListBuyer, selectedDate, selectedDestination, userData]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const clearDateFilter = () => {
    setSelectedDate(null);
  };

  const handleForDestinationChange = (value) => {
    setSelectedDestination(value);
  };

  const fetchSubscription = async () => {
    try {
      const response = await axiosInstance.get(
        `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
      );
      setUserSubscription(response.data);
      setUserSubscription(response.data.subscription);
    } catch (err) {
      console.error("Subscription fetch error:", err);
    }
  };

  useEffect(() => {
    fetchSubscription();
    // dispatch(getOfferProductsActionForBuyer());
    // dispatch(getProductsAction());
  }, [dispatch]);

  const productLimit = useMemo(() => {
    if (!userSubscription) return 5;

    const isSubscriptionExpired = userSubscription.endDate
      ? new Date(userSubscription.endDate) < new Date()
      : false;

    if (isSubscriptionExpired) return 5;

    switch (userSubscription.planId) {
      case 1:
        return 5; // Free
      case 2:
        return 10; // Standard
      case 3:
        return 20; // Premium
      default:
        return 5; // Fallback
    }
  }, [userSubscription]);

  const currentProductCount = useMemo(() => {
    return offerProductListBuyer?.length || 0;
  }, [offerProductListBuyer]);

  const canCreateMoreProducts = currentProductCount < productLimit;

  const checkProductLimit = useCallback(() => {
    if (!userSubscription) {
      notification.warning({
        message: "Subscription Loading",
        description: "Please wait while we verify your subscription",
      });
      return false;
    }
    if (!canCreateMoreProducts) {
      Modal.confirm({
        title: (
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <ExclamationCircleFilled
              style={{ color: "#faad14", fontSize: 20 }}
            />
            <span>Product Limit Reached</span>
          </div>
        ),
        icon: null, // We're customizing the title instead
        width: 500,
        centered: true,
        content: (
          <div style={{ padding: "14px 0" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "12px 16px",
                backgroundColor: "#fffbe6",
                borderRadius: 8,
                marginBottom: 12,
              }}
            >
              <InfoCircleFilled style={{ color: "#faad14", fontSize: 18 }} />
              <div>
                <p style={{ margin: 0, fontWeight: 500 }}>
                  You've reached your free tier limit
                </p>
                <p style={{ margin: "4px 0 0 0", color: "#666" }}>
                  {/* {currentCount}/{productLimit} freight rates used */}
                </p>
              </div>
            </div>

            <div style={{ marginBottom: 20 }}>
              <h4 style={{ marginBottom: 8 }}>Upgrade Benefits:</h4>
              <ul
                style={{
                  margin: 0,
                  paddingLeft: 20,
                  listStyleType: "none",
                }}
              >
                <li
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <CheckCircleFilled
                    style={{ color: "#52c41a", marginRight: 8, marginTop: 4 }}
                  />
                  <span> Can Add 10-20 Products</span>
                </li>
                <li
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <CheckCircleFilled
                    style={{ color: "#52c41a", marginRight: 8, marginTop: 4 }}
                  />
                  <span>Priority listing in Product marketplace</span>
                </li>
                <li style={{ display: "flex", alignItems: "flex-start" }}>
                  <CheckCircleFilled
                    style={{ color: "#52c41a", marginRight: 8, marginTop: 4 }}
                  />
                  <span>Advanced analytics dashboard</span>
                </li>
              </ul>
            </div>
          </div>
        ),
        okText: (
          <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <RocketOutlined />
            Upgrade Plan
          </span>
        ),
        cancelText: "Maybe Later",
        okButtonProps: {
          style: { background: "#1890ff", borderColor: "#1890ff" },
        },
        onOk: () => history.push("/subscription-User"),
      });
      return false;
    }
    return true;
  }, [userSubscription, canCreateMoreProducts, history]);

  const onShowSizeChange = useCallback(
    (current, pageSize) => {
      //   dispatch(getExporterOfferProductsAction(current, pageSize));
    },
    [dispatch]
  );

  const navigateToDetails = useCallback(
    (id) => {
      history.push(`cargo-offers-buyer/details?id=${id}`);
    },
    [history]
  );

  const handleCreateProduct = useCallback(() => {
    if (!checkProductLimit()) return;
    navigateToDetails();
  }, [checkProductLimit, navigateToDetails]);

  const moreActionsRenderer = useCallback(
    (record) => {
      const now = new Date();
      const expiryDate = new Date(record.expiryDate);
      const today = new Date(now.setHours(0, 0, 0, 0));
      const expiryDay = new Date(expiryDate.setHours(0, 0, 0, 0));

      const isExpired = today > expiryDay;
      return (
        <div
          className="myexim-action-icon"
          onClick={(e) => e.stopPropagation()}
        >
          <Space size={4} style={{ marginRight: 0 }}>
            <Button
              type="link"
              disabled={isExpired}
              style={{ backgroundColor: "#28a745", color: "#fff" }}
              onClick={() => {
                if (!isExpired) openModal(record, "block");
              }}
            >
              Block the rate
            </Button>
            <Button
              type="link"
              disabled={isExpired}
              style={{ backgroundColor: "#ff9800", color: "#fff" }}
              onClick={() => {
                if (!isExpired) openModal(record, "negotiate");
              }}
            >
              Negotiate
            </Button>
            <Button
              type="link"
              style={{ backgroundColor: "#5432dcff", color: "#fff" }}
              onClick={() => {
                navigateToDetails(record?.id);
              }}
            >
              <EyeOutlined />
            </Button>
          </Space>
        </div>
      );
    },
    [navigateToDetails]
  );

  const columns = useMemo(
    () => [
      {
        title: "Updated Date",
        dataIndex: "updatedAt",
        width: "20%",
        render: (updatedAt) => <div>{formatDate(updatedAt)}</div>,
      },
      {
        title: "Product Name",
        dataIndex: "name",
        width: "20%",
        render: (text, record) => (
          <div className={"highlighted-column"}>{text}</div>
        ),
      },
      {
        title: isBuyer(userData)
          ? "FOB Price"
          : `FOR Price ${selectedDestination ? `(${selectedDestination})` : ""
          }`,
        dataIndex: "price",
        render: (price, record) => (
          <div>{`${record.currency} ${price} / ${record.uom || ""}`}</div>
        ),
      },
      {
        title: "Status",
        dataIndex: ["createdAt", "expiryDate"],
        render: (_, record) => {
          const now = new Date();
          const createdAt = new Date(record.createdAt);
          const expiryDate = new Date(record.expiryDate);
          const today = new Date(now.setHours(0, 0, 0, 0));
          const expiryDay = new Date(expiryDate.setHours(0, 0, 0, 0));

          const hoursSinceCreation = (now - createdAt) / (1000 * 60 * 60);
          const isExpired = today > expiryDay;

          if (isExpired) {
            return <Tag color="red">Expired</Tag>;
          } else if (hoursSinceCreation <= 24) {
            return <Tag color="green">New</Tag>;
          } else {
            return <Tag color="blue">Active</Tag>;
          }
        },
      },
      {
        title: "Actions",
        key: "actions",
        render: moreActionsRenderer,
      },
    ],
    [moreActionsRenderer, selectedDestination, userData]
  );

  const renderContent = useCallback(
    (data, count) => {
      return isMobile ? (
        <Card bodyStyle={{ padding: 0 }}>
          {data.map((record) => {
            return (
              <div
                className="item-detail-mobile gx-flex-row gx-pointer gx-border-bottom gx-align-items-center"
                onClick={() => navigateToDetails(record.id)}
              >
                {/* <div className="item-image">
                  <Image
                    className="gx-rounded-lg gx-size-60 gx-border-2"
                    preview={false}
                    alt={record.images?.[0].originalName || "No Image"}
                    src={record?.primaryImage}
                    fallback="data:image/png;base64,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"
                  />
                </div> */}
                <div className="item-details gx-flex-1 gx-flex-column">
                  <div className="item-posted-date">
                    Updated Date {formatDate(record?.updatedAt)}
                  </div>
                  <div className="item-primary-row highlighted-column gx-flex-row gx-justify-content-between">
                    <div className="item-primary-text">{record?.name}</div>
                  </div>
                  <div className="item-additional-content gx-flex-row gx-justify-content-between gx-align-items-center">
                    <div className="item-secondary-text">
                      <span style={{ color: "#555555", fontWeight: 600 }}>
                        Offer Price:{" "}
                      </span>
                      <span style={{ fontWeight: 500 }}>{`${record.currency} ${record.price
                        } / ${record.uom || ""}`}</span>
                    </div>
                  </div>
                  <div className="item-additional-content gx-flex-row gx-justify-content-between gx-align-items-center">
                    <div>
                      {(() => {
                        const now = new Date();
                        const createdAt = new Date(record.createdAt);
                        const expiryDate = new Date(record.expiryDate);
                        const today = new Date(now.setHours(0, 0, 0, 0));
                        const expiryDay = new Date(
                          expiryDate.setHours(0, 0, 0, 0)
                        );

                        const hoursSinceCreation =
                          (now - createdAt) / (1000 * 60 * 60);
                        const isExpired = today > expiryDay;

                        if (isExpired) {
                          return <Tag color="red">Expired</Tag>;
                        } else if (hoursSinceCreation <= 24) {
                          return <Tag color="green">New</Tag>;
                        } else {
                          return <Tag color="blue">Active</Tag>;
                        }
                      })()}
                    </div>
                    <div style={{ marginTop: "10px" }}>
                      {moreActionsRenderer(record)}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </Card>
      ) : (
        <Table
          rowClassName={(_, index) =>
            index % 2 === 0 ? "table-row-light" : "table-row-dark"
          }
          onRow={(record) => {
            return {
              onClick: () => {
                navigateToDetails(record?.id);
              },
            };
          }}
          className="gx-table-responsive my-product-table myexim-table"
          total={count}
          columns={columns}
          dataSource={data}
          pagination={{
            position: ["bottomRight"],
            showSizeChanger: true,
            pageSize: 10,
            total: count,
            onChange: onShowSizeChange,
            showTotal: (total, range) =>
              `${range[0]}-${range[1]} of ${total} items`,
          }}
        />
      );
    },
    [
      columns,
      isMobile,
      moreActionsRenderer,
      navigateToDetails,
      onShowSizeChange,
    ]
  );
  return (
    <>
      <Card
        bodyStyle={{ padding: "24px" }}
        style={{ width: "100%" }}
        title={
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "20px",
            }}
          >
            <div style={{ display: "flex", gap: "10px" }}>
              <div className="myexim-table-title">Market Watch</div>
              {!isBuyer(userData) && (
                <Select
                  value={selectedDestination}
                  onChange={handleForDestinationChange}
                  options={FOR_DESTINATIONS.map((item) => ({
                    value: item,
                    label: item,
                  }))}
                  style={{ width: 200 }}
                >
                  {FOR_DESTINATIONS.map((destinationPort) => (
                    <Select.Option
                      key={destinationPort}
                      value={destinationPort}
                    >
                      {destinationPort}
                    </Select.Option>
                  ))}
                </Select>
              )}
            </div>
            <div>
              <DatePicker
                style={{ width: "100%" }}
                format="DD-MM-YYYY"
                placeholder="Filter date"
                value={selectedDate}
                onChange={handleDateChange}
                allowClear={true}
                onClear={clearDateFilter}
                getPopupContainer={(trigger) => trigger.parentNode}
              />
            </div>
          </div>
        }
      ></Card>

      <div>
        {isArrayNonEmpty(filteredOfferProductList)
          ? renderContent(
            filteredOfferProductList,
            filteredOfferProductList.length
          )
          : !loading && <ListEmptyComponent message="No Offers available" />}
      </div>
      <BuyerOfferProductModal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onSave={handleSave}
        form={form}
        initialValues={selectedRecord}
        isNegotiation={isNegotiation}
        loading={isSubmitting}
      />
    </>
  );
};

export default AdminToBuyerOfferProductList;

